import {DESTRUCTIVE_STYLES} from 'components/design-guide/Action/Button/styles/destructive';
import {PILL_STYLES} from 'components/design-guide/Action/Button/styles/pill';
import {PRIMARY_STYLES} from 'components/design-guide/Action/Button/styles/primary';
import {SECONDARY_STYLES} from 'components/design-guide/Action/Button/styles/secondary';
import {SELECTOR_STYLES} from 'components/design-guide/Action/Button/styles/selector';
import {SELECTOR_TOGGLE_STYLES} from 'components/design-guide/Action/Button/styles/selectorToggle';
import {TERTIARY_STYLES} from 'components/design-guide/Action/Button/styles/tertiary';
import {TOUCHPOINT_STYLES} from 'components/design-guide/Action/Button/styles/touchpoint';
import {ButtonStateStyles} from 'components/design-guide/Action/Button/styles/types';
import {ButtonState} from 'components/design-guide/Action/Button/types';
import {ButtonStyle} from 'components/design-guide/enums';

export const BUTTON_TYPE_TO_STYLE_MAP = new Map<ButtonStyle, Map<ButtonState, ButtonStateStyles>>([
  [ButtonStyle.PRIMARY, PRIMARY_STYLES],
  [ButtonStyle.SECONDARY, SECONDARY_STYLES],
  [ButtonStyle.TERTIARY, TERTIARY_STYLES],
  [ButtonStyle.DESTRUCTIVE, DESTRUCTIVE_STYLES],
  [ButtonStyle.PILL, PILL_STYLES],
  [ButtonStyle.SMALL_PILL, PILL_STYLES],
  [ButtonStyle.TOUCHPOINT, TOUCHPOINT_STYLES],
  [ButtonStyle.SELECTOR, SELECTOR_STYLES],
  [ButtonStyle.SELECTOR_TOGGLE, SELECTOR_TOGGLE_STYLES]
]);
